import type { TColorVariant } from '@klv/shared/styles/types';

import lakePoppyGradient from './gradients/lakePoppy.webp';
import lemonPoppyGradient from './gradients/lemonPoppy.webp';
import sagePoppyGradient from './gradients/sagePoppy.webp';
import lavenderPoppyGradient from './gradients/lavenderPoppy.webp';
import lightSandPoppyGradient from './gradients/lightSandPoppy.webp';
import { DARK_BACKGROUNDS, LIGHT_BACKGROUNDS, BACKGROUND_GRADIENTS } from '@klv/shared/utils/variables';
import type { TBackgroundColor } from './types';

export const getBackgroundColor = (backgroundColor?: TBackgroundColor) => {
  if (backgroundColor === 'dark') {
    return 'charcoal';
  }
  if (backgroundColor === 'light') {
    return 'cotton';
  }
  return backgroundColor;
};

export const getBackgroundType = (backgroundColor?: TBackgroundColor): TColorVariant => {
  if (['light', 'dark'].includes(backgroundColor || '')) {
    return backgroundColor as TColorVariant;
  }
  return (DARK_BACKGROUNDS.includes(backgroundColor || '')) ? 'dark' : 'light';
};

// what color goes behind the gradient
export const getBackdropColor = (backgroundColor: TBackgroundColor) => {
  return (backgroundColor === 'light' || LIGHT_BACKGROUNDS.includes(backgroundColor)) ? 'cotton' : 'charcoal'; 
};

// determine the text color based on the background color
export const getTextColor = (backgroundColor: TBackgroundColor) => {
  if (backgroundColor === 'transparent') {
    return 'inherit';
  }
  return (backgroundColor === 'light' || LIGHT_BACKGROUNDS.includes(backgroundColor)) ? 'charcoal' : 'white'; 
};

// determine if the background color is a gradient
export const isGradient = (backgroundColor: TBackgroundColor) => {
  return BACKGROUND_GRADIENTS.includes(backgroundColor);
};

// obtain the correct background image for the gradient
export const getBackgroundImage = (backgroundColor: TBackgroundColor) => {
  if (!isGradient(backgroundColor)) {
    return '';
  }
  const gradientMap: Record<string, string> = {
    lakePoppy: lakePoppyGradient,
    lemonPoppy: lemonPoppyGradient,
    sagePoppy: sagePoppyGradient,
    lavenderPoppy: lavenderPoppyGradient,
    lightSandPoppy: lightSandPoppyGradient,
  };

  const backgroundImage = gradientMap[backgroundColor] || lakePoppyGradient;

  const backdropColor =  getBackdropColor(backgroundColor);
  return `url(${backgroundImage}), linear-gradient(var(--color-${backdropColor}), var(--color-${backdropColor}))`;
};

// translate legacy padding values to new padding values
export const getPadding = (customPadding: string) => {
  if (customPadding === 'default') {
    return 'md';
  }
  if (customPadding === 'small') {
    return 'sm';
  }
  if (customPadding === 'none') {
    return 'xs';
  }
  return customPadding;
};
